module.exports = "/static/media/messagesContent.988bd17b.svg";